var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 33C17.5032 33 17.008 32.8148 16.601 32.4426C15.1578 31.1408 13.7587 29.8863 12.4952 28.8169C8.88641 25.6106 5.72871 22.8671 3.56297 20.1709C1.12775 17.1498 0 14.2685 0 11.1549C0 8.08658 0.99206 5.29766 2.84229 3.25352C4.69253 1.16197 7.26344 0 10.0599 0C12.1357 0 14.03 0.697183 15.6987 1.99896C16.555 2.69615 17.3233 3.48592 18 4.46272C18.6767 3.48592 19.4432 2.69615 20.3013 1.99896C21.97 0.65182 23.8643 0 25.9401 0C28.7366 0 31.2635 1.16197 33.1577 3.25352C35.0079 5.29785 36 8.1338 36 11.1549C36 14.3159 34.8722 17.1498 32.437 20.1709C30.2714 22.867 27.1136 25.6085 23.5048 28.8169C22.2872 29.8863 20.844 31.1408 19.399 32.4426C18.992 32.8148 18.4968 33 17.9999 33H18.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearth);
export default __webpack_public_path__ + "static/media/hearth.046612c2fb40ac89706feebc59141ab3.svg";
export { ForwardRef as ReactComponent };